module.exports = __webpack_public_path__ + "static/trust-us-9ec32dae09dde6ae8ca0a125cd2cea15.svg";